export function getDomainSlug(): string | null {
    const { hostname, port } = window.location;
    const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1";
    const isApp = hostname === "app.trigger-flow.com";

    if ((isLocalhost && (port === "3000" || port === "")) || isApp) return null;

    return hostname;
}

